module.exports = __webpack_public_path__ + "img/Logo.b57a5126.svg";